// @flow
'use strict';

import { connect } from 'react-redux';

import CampoMunicipio from './campo_municipio';

export default connect<*, *, *, *, *, *>()(CampoMunicipio);
